import type { ClientOverviewRepository } from "../repositories/ClientOverviewRepository";
import type { CashInOutInsightsEntity } from "../entities/CashInOutInsightsEntity";

export class GetCashInOutInsightsUseCase {
  constructor(private readonly repository: ClientOverviewRepository) {}

  async execute(): Promise<CashInOutInsightsEntity> {
    return this.repository.getCashInOutInsights();
  }
}

